import { create } from "zustand";

interface ProgressStoreState {
  isLoading: boolean,
  setLoading: (isLoading: boolean) => void;
}

export const useProgressStore = create<ProgressStoreState>((set, _get) => ({
  isLoading: false,
  setLoading: (isLoading: boolean) => {
    set({isLoading});
  },
}));
